import React, { useEffect, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { css, SerializedStyles } from '@emotion/react';
import { DropDownMenu, SelectSection, OptionList, OptionOrderList } from './style';

export interface StyledProps {
  styles?: SerializedStyles;
}

export type DropDownItemType = {
  label: string;
  value: string;
  desc?: string;
  selected?: boolean | undefined;
};

export type DropDownProps = {
  type?: string;
  list: DropDownItemType[];
  synchronize?: boolean;
  onSelected?: (value: DropDownItemType, type?: any) => void;
  placeholder?: string;
  disabled?: boolean;
  selected?: string;
} & StyledProps;

const Select = ({
  type,
  list,
  styles = css``,
  onSelected,
  placeholder,
  disabled,
  selected,
  synchronize,
}: DropDownProps) => {
  const [value, setValue] = useState<DropDownItemType | undefined>(
    list.find((selectItem) => (selected ? selectItem.value === selected : !!selectItem.selected)),
  );

  const [isOpen, setIsOpen] = useState(false);
  /**
   * 자신 이외 선택시 close
   */
  const dropDownEl = useRef<any>(null);

  const handleClickOutside = ({ target }: MouseEvent) => {
    if (target) {
      if (isOpen && !dropDownEl.current?.contains(target)) {
        setIsOpen(false);
      }
    }
  };
  /**
   * 양방향 데이터 바인딩을 위한 작업
   */
  useEffect(() => {
    if (synchronize === true) {
      const newValue = list.find((selectItem) => (selected ? selectItem.value === selected : !!selectItem.selected));
      setValue(newValue);
    }
  }, [list, value, selected, synchronize]);

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  });

  return (
    <DropDownMenu styles={styles} ref={dropDownEl} key={type}>
      <SelectSection
        className={`result-dropdown ${disabled ? 'disabled' : ''} ${isOpen ? 'open' : ''}`}
        onClick={(e: any) => {
          if (disabled) return false;
          setIsOpen(!isOpen);
        }}
      >
        {value?.label || list[0].label || placeholder}
      </SelectSection>

      {isOpen && (
        <OptionList data-is={''}>
          {list.map((item: any) => (
            <OptionOrderList
              key={uuid()}
              align={'left'}
              data-label={item.label}
              data-value={item.value}
              data-desc={item.desc}
              onClick={(e: any) => {
                if (synchronize !== true) setValue({ ...e.target.dataset });
                if (onSelected) onSelected({ ...e.target.dataset }, type);

                if (e.target.parentElement && e.target.parentElement.previousSibling) {
                  e.target.parentElement.dataset.is = '';
                  e.target.parentElement.previousSibling.dataset.is = '';
                }
              }}
            >
              {item.label}
            </OptionOrderList>
          ))}
        </OptionList>
      )}
    </DropDownMenu>
  );
};

export default Select;
